﻿(function () {
    "use strict";

    var app = angular.module("app");

    app.filter('fromNow', function () {
        return function (value, format) {
            format = format || 'MM/DD/YYYY';
            const m = moment(value, ['MM/DD/YYYY', 'MMM DD, YYYYY', 'YYYY-MM-DDThh:mm:ss']);

            return m.isValid() ? m.fromNow() : '';
        };
    });

    app.filter('urlDate', function () {
        return function (value) {
            const m = moment(value, ['MM/DD/YYYY', 'MMM DD, YYYYY', 'YYYY-MM-DDThh:mm:ss']);
            return m.isValid() ? m.format('YYYYMMDD') : '';
        };
    });

})();
